"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../constants");

var UPCOMING_EVENTS_THRESHOLD = 0;
var FOLLOWERS_THRESHOLD = 4;

var shouldShowDataPoint = function shouldShowDataPoint(customDataPoint, numUpcomingEvents, numFollowers) {
  var shouldHideDefaultDataPointMessage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hasCustomDataPoint = !!customDataPoint;
  var hasValidNumUpcomingEvents = !!numUpcomingEvents && numUpcomingEvents > UPCOMING_EVENTS_THRESHOLD;
  var hasValidNumFollowers = !!numFollowers && numFollowers > FOLLOWERS_THRESHOLD;
  return hasCustomDataPoint || hasValidNumUpcomingEvents || hasValidNumFollowers || !shouldHideDefaultDataPointMessage;
};

var getDataPointText = function getDataPointText(customDataPoint, numUpcomingEvents, numFollowers) {
  var dataPointText = customDataPoint || numUpcomingEvents && numUpcomingEvents > UPCOMING_EVENTS_THRESHOLD && (0, _constants.getUpcomingEventCopy)(numUpcomingEvents) || numFollowers && numFollowers > FOLLOWERS_THRESHOLD && (0, _constants.getFollowersCopy)(numFollowers);
  return dataPointText ? dataPointText : _constants.defaultDataPointText.toString();
};

var _default = {
  shouldShowDataPoint: shouldShowDataPoint,
  getDataPointText: getDataPointText
};
exports.default = _default;